import React from 'react';

import { SalesReturnIcon } from '../../Assets/Navigation/NavigationIcons';

import Email from '../../Components/Email/Email';
import { t } from 'i18next';

export default (props) => {
  return (
    <Email
      {...props}
      Icon={SalesReturnIcon}
      name={t('saleOrder.sales_return')}
      onCancelURL="/salesreturns"
      emailAPI={`salesreturns/${props.match.params.id}/mail`}
      fetchDataAPI={`salesreturns/${props.match.params.id}/mail`}
      getBackTab
    />
  );
};
